import React, { useContext, useEffect, useState } from "react";
import helpTokens from "@amzn/meridian-tokens/base/icon/help";
import helpImage from "../assets/ic_help_coming_up.png";
import {
  TopNavigationView,
  HelpView,
  BackPressedView,
} from "@amzn/dolphin-uiweb-framework";
import { Constants, NativeMeshInteractor } from "@amzn/dolphin-web-framework";
import Column from "@amzn/meridian/column";
import { AppContext } from "../context/app-context";
import { STRINGS } from "../locale/strings";
import {
  clearBackPressedEventListener,
  setBackPressedEventListener,
} from "../bridge/back-button.js";
import { ROUTE_PATH } from "../routing.js";
import { VSAContext } from "../context/vsa-context.js";
import { generateReportsForVSAFromVehicleInspectionDetailsResponse } from "./vin-scanning/utils/generate-reports.js";
import { DevContext } from "src/context/dev-context";
import { useHistory } from "react-router-dom";

export default function AppTopNavigation(props) {
  const history = useHistory();
  const { appState, formatMessage, appActions } = useContext(AppContext);
  const { vsaState, vsaActions } = useContext(VSAContext);
  const { devActions } = useContext(DevContext);
  const [shouldTriggerBackAction, setShouldTriggerBackAction] =
    React.useState(false);
  const [shouldUpdateCategory, setShouldUpdateCategory] = React.useState(false);

  const overideBackButtonAction = () => {
    appActions.onBackPressed();
    setShouldTriggerBackAction(true);
  };

  //Behaviour of back press related to a particular screen
  const handleBackPress = () => {
    const hash = window.location.hash.slice(1);
    if (appState.helpOptions.open) {
      appActions.closeHelp();
    } else if (appState.backOptions.open) {
      appActions.closeBackOptions();
    } else {
      switch (hash) {
        case ROUTE_PATH.INDEX.PATH:
          appActions.openBackOptions();
          break;
        case ROUTE_PATH.SCAN_VIN_LANDING.PATH:
          appActions.openBackOptions();
          break;
        case ROUTE_PATH.SCAN_VIN.PATH:
          history.push(ROUTE_PATH.SCAN_VIN_LANDING.PATH);
          break;
        case ROUTE_PATH.MANUAL_VIN_INPUT.PATH:
          history.push(ROUTE_PATH.SCAN_VIN_LANDING.PATH);
          break;
        case ROUTE_PATH.OPERATIONAL_STATUS.PATH:
          //Clear data when you go back from OperationalStatus
          vsaActions.clearData();
          //Clears the mocked KITTVehicleInspectionDetails for mocking
          devActions.updateVehicleInspectionDetails("");
          history.push(ROUTE_PATH.SCAN_VIN_LANDING.PATH);
          break;
        case ROUTE_PATH.VIEW_ISSUES.PATH:
          history.push(ROUTE_PATH.OPERATIONAL_STATUS.PATH);
          break;
        case ROUTE_PATH.CERTIFY_REPAIRS.PATH:
          history.push(ROUTE_PATH.OPERATIONAL_STATUS.PATH);
          break;
        case ROUTE_PATH.START_VSA.PATH:
          //Reset report
          generateReportsForVSAFromVehicleInspectionDetailsResponse(
            vsaState.vehicleInspectionDetails,
            vsaActions
          );
          history.push(ROUTE_PATH.OPERATIONAL_STATUS.PATH);
          break;
        case ROUTE_PATH.MOVE_TO_LOCATION.PATH:
          if (vsaState.currentMoveToLocationIndex <= 0) {
            history.push(ROUTE_PATH.START_VSA.PATH);
            break;
          } else {
            vsaActions.decrementMoveToLocationIndex();
            setShouldUpdateCategory(true);
            break;
          }
        case ROUTE_PATH.INSPECTION_CATEGORY.PATH:
          if (vsaState.currentCategoryIndex === 0) {
            history.push(ROUTE_PATH.MOVE_TO_LOCATION.PATH);
            break;
          } else {
            vsaActions.decrementCurrentCategoryIndex();
            break;
          }
        default:
          history.goBack();
          break;
      }
    }
  };

  //Trigger this once MoveToLocationIndex state change happened
  React.useEffect(() => {
    if (shouldUpdateCategory) {
      //Reassign currentCategoryIndex as last category from previous location
      vsaActions.updateCurrentCategoryIndex(
        vsaState.vehicleInspectionTemplate.locations[
          vsaState.currentMoveToLocationIndex
        ].categories.length - 1
      );
      history.push(ROUTE_PATH.INSPECTION_CATEGORY.PATH);
      setShouldUpdateCategory(false);
    }
  }, [shouldUpdateCategory]);

  //Once the backbutton is pressed, this ensures the state is initialised and usable to the user
  React.useEffect(() => {
    if (shouldTriggerBackAction) {
      handleBackPress();
      setShouldTriggerBackAction(false);
    }
  }, [shouldTriggerBackAction]);

  //Trigger the back press override listener
  React.useEffect(() => {
    console.log("setBackPressedEventListener changes");
    setBackPressedEventListener(overideBackButtonAction);
    return clearBackPressedEventListener;
  }, [appState.onBackPressed]);

  return (
    <Column id="app-header" width="100%" spacingInset="none" spacing="none">
      <TopNavigationView
        title={appState.title}
        backgroundType={appState.topNavigationBackground}
        stage={Constants.Stage.GAMMA}
        region={Constants.Region.REGION_EU}
        onMenuButtonClicked={overideBackButtonAction}
        optionsMenu={[
          {
            icon: helpTokens,
            onClick: () => {
              appActions.openHelp();
            },
          },
        ]}
      />
      {appState.helpOptions.open && (
        <HelpView
          help_icon={helpImage}
          onClose={() => {
            appActions.closeHelp();
          }}
          stage={Constants.Stage.GAMMA}
          region={Constants.Region.REGION_EU}
          title={formatMessage(STRINGS.vsa_help_options_title)}
          pageTitle={"Help menu"}
          list={appState.helpOptions.list}
          createHelpRequestOptionTitle={formatMessage(STRINGS.urgent_help)}
        />
      )}
      {appState.backOptions.open && (
        <BackPressedView
          onClose={appActions.closeBackOptions}
          title={formatMessage(STRINGS.back_press_title)}
          description={formatMessage(STRINGS.back_press_description)}
          primaryButtonTitle={formatMessage(STRINGS.back_press_primary)}
          secondaryButtonTitle={formatMessage(STRINGS.back_press_secondary)}
          primaryButtonOnClick={() => appActions.closeBackOptions()}
          secondaryButtonOnClick={() => NativeMeshInteractor.exitModule()}
        />
      )}
    </Column>
  );
}
